module.exports = require("./az-Latn-AZ.js");